import { render, staticRenderFns } from "./BolsaAppFooter.vue?vue&type=template&id=18883ce0&scoped=true"
import script from "./BolsaAppFooter.vue?vue&type=script&lang=js"
export * from "./BolsaAppFooter.vue?vue&type=script&lang=js"
import style0 from "./BolsaAppFooter.vue?vue&type=style&index=0&id=18883ce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18883ce0",
  null
  
)

export default component.exports